import { Box, Typography } from '@mui/material';
import CustomCard from 'components/shared/CustomCard/CustomCard';
import CustomModal from 'components/shared/CustomModal/CustomModal';
import { ModalAction } from 'model/modal.model';
import { Dispatch } from 'react';
import { useNavigate } from 'react-router-dom';
import zeplinColor from 'theme/Color';

const CancelModal = ({ state, dispatch }: { state: boolean; dispatch: Dispatch<ModalAction> }) => {
  const navigate = useNavigate();

  return (
    <CustomModal
      handleClose={() => dispatch({ type: 'CLOSE', payload: 'cancelEdit' })}
      open={state}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <CustomCard
          styles={{
            borderRadius: '14px',
            padding: '24px',
            backgroundColor: zeplinColor.Neutral1,
            width: '500px',
            boxShadow: 'rgba(0, 0, 0, 0.15)',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                Discard new changes?
              </Typography>
              <Typography variant='body2' color={zeplinColor.BasicBlack}>
                You will lose all changes made. Are you sure you want to continue?
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: '16px' }}>
              <Box
                onClick={() => dispatch({ type: 'CLOSE', payload: 'cancelEdit' })}
                sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
              >
                <CustomCard
                  styles={{
                    borderRadius: '14px',
                    padding: '14px 32px',
                    backgroundColor: zeplinColor.Neutral1,
                    border: `1px solid ${zeplinColor.BasicBlack}`,
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'center',
                    flex: 1,
                  }}
                >
                  <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                    Keep Editing
                  </Typography>
                </CustomCard>
              </Box>
              <Box
                onClick={() => {
                  dispatch({ type: 'CLOSE', payload: 'cancelEdit' });
                  navigate(-1);
                }}
                sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
              >
                <CustomCard
                  styles={{
                    borderRadius: '14px',
                    padding: '14px 32px',
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'center',
                    flex: 1,
                    bgcolor: zeplinColor.Error,
                  }}
                  aria-label='button'
                >
                  <Typography
                    variant='buttonMedium'
                    color={zeplinColor.Neutral1}
                    sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                  >
                    Discard Changes
                  </Typography>
                </CustomCard>
              </Box>
            </Box>
          </Box>
        </CustomCard>
      </Box>
    </CustomModal>
  );
};

export default CancelModal;
